<!-- Área Drag & Drop -->
<div
  class="irx-clickeable dropzone"
  role="button"
  tabindex="0"
  [class.dragover]="isDragOver"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="fileInput.click()"
  (keydown.enter)="fileInput.click()"
>
  <input
    #fileInput
    type="file"
    [multiple]="allowMultiple"
    [disabled]="disabled"
    [attr.accept]="acceptedTypes || null"
    (change)="onFileChange($event)"
    style="display: none"
  />

  <div class="dropzone-content">
    <p>{{ textoDrag }}</p>
    <button
      irxBoton="tonal"
      [disabled]="disabled || (maxFiles && archivos.length >= maxFiles)"
      (click)="$event.stopPropagation(); fileInput.click()"
      class="btn-subir-archivo"
    >
      <mat-icon>upload</mat-icon>
      <span>{{ textoBoton }}</span>
    </button>
  </div>
</div>

<!-- Cargando -->
@if (isUploading) {
  <div class="uploading-spinner">
    <mat-spinner diameter="30"></mat-spinner>
  </div>
}

<!-- Archivos subidos -->
@if (archivos?.length > 0) {
  <div class="lista-archivos">
    @for (archivo of archivos; track archivo; let i = $index) {
      <div class="archivo-item">
        <div class="preview">
          @switch (getVistaPreviaTipo(archivo)) {
            <!-- Imagen -->
            @case ('imagen') {
              <img [src]="archivo.url" alt="preview" class="preview-img" />
            }
            <!-- Otros (PDF, Word, Excel, etc.) -->
            @default {
              <mat-icon>{{ getIconoArchivo(archivo.nombreOriginal) }}</mat-icon>
            }
          }
        </div>
        <div class="info">
          <strong>{{ archivo.nombreOriginal }}</strong>
          @if (descripcion) {
            <div class="descripcion-container">
              <input
                type="text"
                [(ngModel)]="archivo.descripcion"
                (ngModelChange)="actualizarDescripcion(i, $event)"
                placeholder="Agregar una descripción"
                class="descripcion-input"
              />
            </div>
          }
          <em>Subido: {{ archivo.fecha | date: 'short' }}</em>
        </div>
        <button
          irxBotonIcono
          tono="peligro"
          tamano="compacto"
          class="btn-eliminar"
          (click)="eliminarArchivo(i)"
          tooltip="Eliminar archivo"
        >
          <span
            class="material-icons"
            style="font-size: 16px; vertical-align: middle"
          >
            close
          </span>
        </button>
      </div>
    }
  </div>
} @else {
  <span class="no-archivo"></span>
}

<br />

<!-- Contador y tamaño -->
<div>
  <span>
    {{ archivos.length }}
    @if (maxFiles && maxFiles > 0) {
      / {{ maxFiles }}
    }
    archivo(s) subidos
  </span>
  @if (maxTotalSizeMB && maxTotalSizeMB > 0) {
    &nbsp;&nbsp;|&nbsp;&nbsp; Ocupado: {{ bytesToMB(totalSizeBytes) }} /
    {{ maxTotalSizeMB }} MB
  }
</div>
